import { format } from "date-fns";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CrmEmailPreferences } from "@/services/adminCrm";

interface Props {
  emailPreferences?: CrmEmailPreferences;
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return "";
  try {
    return format(new Date(dateStr), "MMM d, yyyy");
  } catch {
    return "";
  }
}

export function UserEmailPrefsSection({ emailPreferences }: Props) {
  if (!emailPreferences) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Email Preferences</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No email preference data available.</p>
        </CardContent>
      </Card>
    );
  }

  const items = [
    {
      label: "Engagement Emails",
      enabled: emailPreferences.engagementEmails,
      unsubDate: emailPreferences.unsubscribedAt,
    },
    {
      label: "Newsletter",
      enabled: emailPreferences.newsletterEmails,
      unsubDate: emailPreferences.newsletterUnsubscribedAt,
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Email Preferences</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 text-sm">
          {items.map(item => (
            <div key={item.label} className="flex items-center justify-between">
              <span className="text-muted-foreground">{item.label}</span>
              <div className="text-right">
                <span
                  className={
                    item.enabled ? "text-green-700 font-medium" : "text-red-600 font-medium"
                  }
                >
                  {item.enabled ? "On" : "Off"}
                </span>
                {!item.enabled && item.unsubDate && (
                  <div className="text-xs text-muted-foreground">
                    Unsubscribed {formatDate(item.unsubDate)}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
